export const CONTACT = {
  phone: "+91 70625 07761",
  phoneRaw: "917062507761",
  tollFree: "+91 91166 65224",
  tollFreeRaw: "919116665224",
  email: "sanwariyaelevator@gmail.com",
  address: [
    "Plot No. 121 & 122",
    "Birjpura, Jagat Puri",
    "Near Punjab National Bank ATM",
    "Jaipur, Rajasthan - 302017",
  ],
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_elevator-solutions-9/artifacts/mfafxyau_sanwariya%20elevator%20logo.png",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.523179302162!2d75.8431952752211!3d26.823307176700574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396dc989d47352c9%3A0xf12c139df37b8919!2sSanwariya%20Elevator!5e0!3m2!1sen!2sin!4v1785746240066!5m2!1sen!2sin",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/11586613/pexels-photo-11586613.jpeg",
  passenger:
    "https://images.pexels.com/photos/32260201/pexels-photo-32260201.jpeg",
  repair: "https://images.unsplash.com/photo-1748027869634-fc2e545cfb0c",
  commercial:
    "https://images.unsplash.com/photo-1566096650255-98ba2641071e",
};

export const SERVICES = [
  {
    icon: "Building2",
    title: "Elevator Installation",
    desc: "Professional installation of Passenger Lifts, Home Lifts, Commercial Lifts and Hospital Lifts.",
    image: IMAGES.passenger,
  },
  {
    icon: "Wrench",
    title: "Elevator Repair",
    desc: "Quick diagnosis and repair services for all major elevator brands.",
    image: IMAGES.repair,
  },
  {
    icon: "ShieldCheck",
    title: "Annual Maintenance (AMC)",
    desc: "Regular maintenance to ensure smooth and safe lift operation all year round.",
    image: IMAGES.commercial,
  },
  {
    icon: "Sparkles",
    title: "Elevator Modernization",
    desc: "Upgrade your existing lift with the latest technology and safety features.",
    image: IMAGES.hero,
  },
  {
    icon: "Siren",
    title: "Emergency Breakdown",
    desc: "Fast response for elevator breakdowns and round-the-clock technical support.",
    image: IMAGES.repair,
  },
  {
    icon: "Cog",
    title: "Genuine Spare Parts",
    desc: "High-quality, genuine elevator spare parts and accessories.",
    image: IMAGES.passenger,
  },
];

export const WHY = [
  "Experienced Engineers",
  "Professional Installation",
  "Affordable Pricing",
  "High Safety Standards",
  "Genuine Spare Parts",
  "On-Time Project Completion",
  "Quality Workmanship",
  "Customer Satisfaction",
  "24×7 Technical Support",
];

export const PROCESS = [
  { n: "01", title: "Site Inspection", desc: "On-site survey to understand the shaft, load and building requirements." },
  { n: "02", title: "Requirement Discussion", desc: "Understanding your usage, capacity and design preferences in detail." },
  { n: "03", title: "Quotation & Planning", desc: "Transparent, affordable quotation with a clear project plan and timeline." },
  { n: "04", title: "Elevator Installation", desc: "Precise, standards-compliant installation by our experienced engineers." },
  { n: "05", title: "Testing & Commissioning", desc: "Rigorous safety testing and certification before handover." },
  { n: "06", title: "Maintenance & Support", desc: "Ongoing AMC, servicing and 24×7 technical support you can rely on." },
];

export const INDUSTRIES = [
  "Residential Buildings",
  "Commercial Buildings",
  "Hospitals",
  "Hotels",
  "Shopping Malls",
  "Schools & Colleges",
  "Factories",
  "Office Buildings",
];
